module.exports = __webpack_public_path__ + "img/1.318242d6.png";